import axios from 'axios'
import getConfig from '../config'
const { API_BASE_URI } = getConfig()

export async function flush () {
  const response = await axios({
    method: 'post',
    url: `${API_BASE_URI}/cache/flush`,
    data: {}
  })
  return response.data
}



// WEBPACK FOOTER //
// ./src/api/cache.js